import cross_en from "./data/en.json";
import cross_zh from "./data/zh.json";

export { cross_en, cross_zh };
